import React, {h, Component} from 'preact';
import constants from "../constants";
import MOTextStyleEdit from "./svg/MOTextStyleEdit";
import util from '../util';

export default class TextStyleWidget extends Component {
    constructor(props) {
        super();
    }

    checkAttrIsVal(theseStyles, attr, val) {
        const allPriceStyles = this.props.type.includes('price-entry') ? this.props.menuObjectStyles['price-entry'] ? this.props.menuObjectStyles['price-entry'] : this.props.menuObjectStyles['price'] ? this.props.menuObjectStyles['price'] : {} : {};
        if (theseStyles[attr]) {
            return theseStyles[attr] === val;
        }
        if (!this.props.type.includes('price-entry')) {
            return false;
        }
        if (allPriceStyles && allPriceStyles[attr]) {
            return allPriceStyles[attr] === val;
        }
        return false;
    }

    toggleBold(e) {
        e.stopPropagation();
        const theseStyles = this.props.menuObjectStyles[this.props.type] ? this.props.menuObjectStyles[this.props.type] : this.props.type.includes('price-entry') ? this.props.menuObjectStyles['price-entry'] : {};
        const isBold = this.checkAttrIsVal(theseStyles, 'font-weight', 'bold');
        this.props.onStyleChange('font-weight', isBold ? 'normal' : 'bold', this.props.priceNum !== null ? this.props.priceNum : null);

        if (util.isSafari()) {
            this.props.onStyleChange('letter-spacing', !isBold ? '-0.02em' : 'normal');
        }
    }

    toggleItalic(e) {
        e.stopPropagation();
        const theseStyles = this.props.menuObjectStyles[this.props.type] ? this.props.menuObjectStyles[this.props.type] : this.props.type.includes('price-entry') ? this.props.menuObjectStyles['price-entry'] : {};
        const isItalic = this.checkAttrIsVal(theseStyles, 'font-style', 'italic');
        this.props.onStyleChange('font-style', isItalic ? 'normal' : 'italic', this.props.priceNum !== null ? this.props.priceNum : null);
    }

    toggleUnderline(e) {
        e.stopPropagation();
        const theseStyles = this.props.menuObjectStyles[this.props.type] ? this.props.menuObjectStyles[this.props.type] : this.props.type.includes('price-entry') ? this.props.menuObjectStyles['price-entry'] : {};
        const isUnderline = this.checkAttrIsVal(theseStyles, 'text-decoration', 'underline');
        this.props.onStyleChange('text-decoration', isUnderline ? 'none' : 'underline', this.props.priceNum !== null ? this.props.priceNum : null);
    }

    toggleUppercase(e) {
        e.stopPropagation();
        const theseStyles = this.props.menuObjectStyles[this.props.type] ? this.props.menuObjectStyles[this.props.type] : this.props.type.includes('price-entry') ? this.props.menuObjectStyles['price-entry'] : {};
        const isUppercase = this.checkAttrIsVal(theseStyles, 'text-transform', 'uppercase');
        this.props.onStyleChange('text-transform', isUppercase ? 'none' : 'uppercase', this.props.priceNum !== null ? this.props.priceNum : null);
    }

    render(props, state) {
        const styles = {
            ...(props.menuObjectStyles[props.type] ? props.menuObjectStyles[props.type] : props.type.includes('price-entry') ? props.menuObjectStyles['price-entry'] : {})
        };        
        const isBold = this.checkAttrIsVal(styles, 'font-weight', 'bold');
        const isItalic = this.checkAttrIsVal(styles, 'font-style', 'italic');
        const isUnderline = this.checkAttrIsVal(styles, 'text-decoration', 'underline');
        const isUppercase = this.checkAttrIsVal(styles, 'text-transform', 'uppercase');

        return (
            <div className="dropdown">
                <a className="dropdown-toggle car sm">
                    <MOTextStyleEdit/>
                </a>
                <div className="dropdown-menu left saf-stop">
                    <div className="text-style-options">
                        <a className={"icn tgl " + (isBold ? 'act' : '')} onClick={this.toggleBold.bind(this)}>
                            <svg>
                                <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-bold"}/>
                            </svg>
                        </a>
                        <a className={"icn tgl " + (isItalic ? 'act' : '')} onClick={this.toggleItalic.bind(this)}>
                            <svg>
                                <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-italic"}/>
                            </svg>
                        </a>
                        <a className={"icn tgl " + (isUnderline ? 'act' : '')} onClick={this.toggleUnderline.bind(this)}>
                            <svg>
                                <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-underline"}/>
                            </svg>
                        </a>
                        {props.type !== 'icon-entry' &&
                        <a style="border: 0" className={"icn tgl " + (isUppercase ? 'act' : '')} onClick={this.toggleUppercase.bind(this)}>
                            <svg>
                                <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-font-size"}/>
                            </svg>
                        </a>}
                    </div>
                </div>
            </div>
        )
    }
}
